import {useQuery} from '@tanstack/react-query';
import {Integration, IntegrationListQueryParams} from 'src/core/data/api/Integration';
import IntegrationService from 'src/services/integration-service';

export const integrationKeys = {
  all: ['integration'] as const,
  filters: () => [...integrationKeys.all, 'filter'] as const,
  filter: (query: IntegrationListQueryParams) => [...integrationKeys.filters(), query] as const,
};

// PRF nao tem credencial pra colocar em Configuracao de Integracao (MON-556): sem isso ela
// aparece na tela de qualquer perfil como uma opcao vazia, sem nada a preencher.
export const withCredential = (integrations: Integration[]): Integration[] => (
  integrations.filter((integration) => !integration.nocredential)
);

export const useIntegrations = (query: IntegrationListQueryParams = {all: true}) => {
  const integrationService = new IntegrationService();

  return useQuery<unknown, unknown, Integration[]>({
    queryKey: integrationKeys.filter(query),
    queryFn: () => integrationService.list(query),
    initialData: [],
  });
};
